import MDModal from "components/MDModal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useContext, useEffect, useState } from "react";
import DataTable from "examples/Tables/DataTable";
import DefaultCell from "examples/Tables/DataTable/components/DefaultCell";
import MDBox from "components/MDBox";
import { ModalContext } from "context/ModalContext";
import { LoginFormContext } from "context/LoginFormContext";
import { MODULES } from "helpers/constant";
import UpdateStatus from "components/MDUpdateStatus";
import defaultImage from "../../../assets/images/placeholder.jpg";
import MDActionButton from "components/MDActionButton";
import colors from "assets/theme/base/colors";
import Imagepreview from "components/MDImagePreview";
import { SEARCH_INPUT_TYPES } from "helpers/constant";
import { updateQrTemplateApi } from "Apis/qrTemplate";
import moment from "moment";
import QrTemplateForm from "./form";
import { fetchQrTemplateListApi } from "Apis/qrTemplate";
import { Chip } from "@mui/material";
import { deleteQrTemplateApi } from "Apis/qrTemplate";
import { getQrTemplateByIdApi } from "Apis/qrTemplate";
import { QrTemplateContext } from "context/QrTemplateContext";

const QrTemplate = () => {
  const { showMessageNotification, setOpen, formIsEdit, setFormIsEdit } = useContext(ModalContext);
  const {
    setNotification,
    modules,
    getModuleAccess,
    access,
    isLoading,
    setIsLoading,
    filterLoader,
    setFilterLoader,
  } = useContext(LoginFormContext);
  const { setEditData } = useContext(QrTemplateContext);
  const [qrTemplateData, setQrTemplateData] = useState([]);
  const { imageBorder } = colors;
  const [rowCount, setRowCount] = useState(0);
  const [defaultFilter, setDefaultFilter] = useState({
    currentPage: 1,
    itemsPerPage: 10,
    sortBy: [{ id: "id", value: "desc" }],
  });
  const handleEditDelete = async (row, type) => {
    if (type === "Edit") {
      setFilterLoader(false);
      let response = await getQrTemplateByIdApi(row.id);
      if (response?.status === 200) {
        setEditData(response?.data?.data);
        setOpen(true);
        setFormIsEdit(true);
      }
    }

    if (type === "Delete") {
      showMessageNotification({
        title: "Are you sure?",
        text: "You want to delete this Template!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result?.isConfirmed) {
          let deleteResponse = await deleteQrTemplateApi(row.id);
          if (deleteResponse?.status === 200) {
            setFilterLoader(false);
            setOpen(false);
            qrTemplateData?.length === 1 && setDefaultFilter({ ...defaultFilter, currentPage: 1 });
            getQrTemplateList();
            setNotification({
              color: "success",
              icon: "check",
              title: "Success",
              content: deleteResponse?.data?.message,
              open: true,
            });
          } else {
            setNotification({
              color: "error",
              icon: "check",
              title: "error",
              content: deleteResponse?.data?.message,
              open: true,
            });
          }
        }
      });
    }
  };

  const [filterVal, setFilterVal] = useState({
    type: "",
    title: "",
    display_order: "",
  });

  const handleFilter = (accessor, value) => {
    setFilterLoader(true);
    setFilterVal({ ...filterVal, [accessor]: value });
    setDefaultFilter((prev) => ({ ...prev, currentPage: 1 }));
  };

  let Obj = {
    ...defaultFilter,
    filters: {
      type: filterVal.type,
      title: filterVal.title,
      display_order: filterVal.display_order,
      is_active: filterVal?.is_active?.value,
      is_show_member_id: filterVal?.is_show_member_id?.value,
    },
  };

  const getQrTemplateList = async () => {
    let response = await fetchQrTemplateListApi(Obj);
    filterLoader ? setIsLoading(false) : setIsLoading(true);
    if (response?.status === 200) {
      setIsLoading(false);
      setQrTemplateData(response?.data?.data?.rows);
      setRowCount(response?.data?.data?.count);
    }
  };

  useEffect(() => {
    getModuleAccess(MODULES.QR_TEMPLATE);
  }, [modules]);

  useEffect(() => {
    getQrTemplateList();
  }, [filterVal, defaultFilter]);

  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsImageModalOpen(true);
  };

  let data = {
    isFilter: true,
    columns: [
      {
        Header: "Template Image",
        accessor: "type",
        // minWidth: "85px",
        sort: false,
        filterLabel: "Type",
        filterAccessor: "type",
        // filterInputType: SEARCH_INPUT_TYPES.TEXT,
        // filterHandleChange: handleFilter,
        Cell: ({ value, row }) => {
          const imageUrl = row?.original?.qr_templates_images?.image;

          const [imgError, setImgError] = React.useState(false);

          return (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {imageUrl && !imgError ? (
                <img
                  src={imageUrl}
                  alt="image"
                  onError={() => setImgError(true)}
                  onClick={() => handleImageClick(imageUrl)}
                  style={{
                    height: "100px",
                    width: "100px",
                    borderRadius: "2%",
                    objectFit: "cover",
                    border: `1px solid ${imageBorder.borderColor}`,
                    cursor: "pointer",
                  }}
                />
              ) : (
                <img
                  src={defaultImage}
                  alt="image"
                  style={{
                    height: "50px",
                    width: "50px",
                    borderRadius: "100%",
                    objectFit: "fill",
                    border: `1px solid ${imageBorder.borderColor}`,
                  }}
                />
              )}
              <DefaultCell
                value={value?.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())}
              />
              {/* <DefaultCell value={value || "-"} /> */}
            </div>
          );
        },
      },
      // {
      //   Header: "Show member Number",
      //   accessor: "is_show_member_id",
      //   sort: false,
      //   filterLabel: "Show member Number",
      //   filterAccessor: "is_show_member_id",
      //   filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
      //   filterHandleChange: handleFilter,
      //   filterOption: [
      //     { label: "Yes", value: "1" },
      //     { label: "No", value: "0" },
      //   ],
      //   Cell: ({ row }) => {
      //     const info = row?.original?.is_show_member_id;
      //     const isYes = info === 1 || info === "1";
      //     return (
      //       <Chip
      //         label={isYes ? "Yes" : "No"}
      //         variant="filled"
      //         size="medium"
      //         sx={{
      //           minWidth: 60,
      //           textTransform: "capitalize",
      //           color: "#fff",
      //           fontWeight: 500,
      //           backgroundColor: isYes ? "#a68181" : "#7f868f",
      //           "&:hover": {
      //             backgroundColor: isYes ? "#a68181" : "#7f868f",
      //           },
      //         }}
      //       />
      //     );
      //   },
      // },
      {
        Header: "Title",
        accessor: "title",
        filterLabel: "Title",
        filterAccessor: "title",
        filterHandleChange: handleFilter,
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        sort: true,
        Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
      },
      {
        Header: "Created date",
        accessor: "createdAt",
        sort: true,
        Cell: ({ value }) => (
          <DefaultCell value={value ? moment(value).format("DD-MM-YYYY hh:mm A") : "-"} />
        ),
      },
      {
        Header: "Status",
        accessor: "is_active",
        // minWidth: "115px",
        sort: false,
        filterLabel: "Status",
        filterAccessor: "is_active",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Active", value: "1" },
          { label: "Inactive", value: "0" },
        ],
        Cell: ({ row }) => (
          <UpdateStatus
            tableNameProp="qr_templates"
            data={row}
            access={access?.write_access ? true : false}
          />
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        width: "12%",
        Cell: ({ value, row }) => (
          <MDBox sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {access?.write_access && (
              <MDActionButton type="edit" onClick={() => handleEditDelete(row?.original, "Edit")} />
            )}
            {access?.delete_access && (
              <MDActionButton
                type="delete"
                onClick={() => handleEditDelete(row?.original, "Delete")}
              />
            )}
          </MDBox>
        ),
      },
    ],
    rows: qrTemplateData,
  };

  return (
    !isLoading && (
      <DashboardLayout>
        <DashboardNavbar />
        <>
          <MDModal
            hasButton={access?.write_access ?? false}
            btnText="Add Qr Template"
            modalHead={`${formIsEdit ? "Edit" : "Add"} Qr Template`}
          >
            <QrTemplateForm getQrTemplateList={getQrTemplateList} />
          </MDModal>
          <DataTable
            table={data}
            isSorted={false}
            entriesPerPage={true}
            showTotalEntries={true}
            noEndBorder
            canFilter
            canSearch={true}
            tableTitle="Qr Template List"
            updateApi={updateQrTemplateApi}
            getDataList={getQrTemplateList}
            rowCount={rowCount}
            defaultFilter={defaultFilter}
            setDefaultFilter={setDefaultFilter}
          />
          {selectedImage && (
            <Imagepreview
              open={isImageModalOpen}
              onClose={() => setIsImageModalOpen(false)}
              imageUrl={selectedImage}
            />
          )}
        </>
      </DashboardLayout>
    )
  );
};

export default QrTemplate;
